import { Button } from "@mui/material";
import { Typography } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Accordion from "@mui/material/Accordion";

export const StyledCardContent = styled(CardContent)`
  color: ${theme.palette.primary.dark};
  // border-right: 4px solid ${theme.palette.primary.dark};
  padding: 10px !important;
  // margin-top: 20px;
  position: relative;
  & p {
    text-align: center;
    padding-top: 10px;
  }
  &::before {
    content: "";
    position: absolute;
    right: 50%;
    left: 50%;
    top: 0px;
    width: 100px;
    border: 3px solid ${theme.palette.primary.dark};
    border-radius: 1px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    pointer-events: none;
    transform: translate(50%);
  }
`;

export const StyledContainer = styled(Container)`
  padding: 0 !important;
  @media (max-width: 900px) {
    padding: 0 !important;
  }
`;

// export const StyledCard = styled(Card)`
//   background-color: ${theme.palette.primary.light} !important;
//   width: 100%;
//   margin-bottom: 10px;
//   position: relative;
// `;
export const StyledCard = styled(Card)`
  background-color: transparent !important;
  width: 100%;
  margin-bottom: 10px;
  position: relative;
  border-radius: 0 !important;
  box-shadow: none !important;
  border-bottom: 2px solid #0000002b;
  // :first-child {
  //   border-top: 2px solid #0000002b;
  //   padding-top: 10px;
  // }
`;

export const StyledTypography = styled(Typography)`
  display: flex;
  align-items: center;
  padding-right: 10px;
  @media (max-width: 900px) {
    font-size: 13px !important;
    margin-top: 4px;
    margin-bottom: 4px;
  }
  line-height: 27px !important;
  color: #070937;
  font-size: 1rem !important;
  font-weight: 200 !important;
`;

export const StyledNewMessage = styled.div`
  padding: 4px;
  background: ${theme.palette.primary.dark};
  display: inline-block;
  position: absolute;
  top: 5px;
  left: 5px;
  color: white;
  border-radius: 4px;
  font-size: 9px;
`;

export const StyledCardActions = styled(CardActions)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px !important;
  padding-top: 0 !important;
  & > p {
    margin: 0;
  }
`;

export const StyledMainWrapper = styled.div`
  height: 100%;
  // display: flex;
  // align-items: flex-start;
  // justify-content: flex-start;
  // margin-left: 20px;
  // margin-top: 70px;
  position: relative;
  padding-top: 30px;

  & > button {
    border: 2px solid ${theme.palette.primary.main};
    position: absolute;
    left: 0px;
    top: 0px;
  }

  @media (max-width: 600px) {
    // margin-bottom: 200px;
    // align-items: center;
    // justify-content: center;
  }
`;
export const StyledButton = styled.button`
  min-width: 180px;
  min-height: 60px;
  font-family: "Avini", sans-serif;
  font-size: 25px;
  text-transform: uppercase;
  letter-spacing: 1.3px;
  font-weight: 700;
  color: white;
  background: ${theme.palette.primary.main};
  background: linear-gradient(
    90deg,
    ${theme.palette.primary.main} 0%,
    ${theme.palette.primary.main} 100%
  );
  border: none;
  border-radius: 1000px;
  box-shadow: 0px 0px 4px ${theme.palette.primary.main};
  transition: all 0.3s ease-in-out 0s;
  cursor: pointer;
  outline: none;
  position: relative;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: "";
    border-radius: 1000px;
    min-width: calc(180px + 12px);
    min-height: calc(65px + 13px);
    border: 4px solid ${theme.palette.primary.main};
    box-shadow: 0 0 10px ${theme.palette.primary.main};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: all 0.3s ease-in-out 0s;
  }

  &:hover,
  &:focus {
    color: white;
    transform: translateY(-6px);
  }

  &:hover::before,
  &:focus::before {
    opacity: 1;
  }

  &::after {
    content: "";
    width: 30px;
    height: 30px;
    border-radius: 100%;
    border: 4px solid ${theme.palette.primary.main};
    position: absolute;
    z-index: -1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: shareButton 1.5s infinite;
  }

  &:hover::after,
  &:focus::after {
    animation: none;
    display: none;
  }

  @keyframes shareButton {
    0% {
      width: 20px;
      height: 20px;
      opacity: 1;
    }
    100% {
      width: 250px;
      height: 120px;
      opacity: 0;
    }
  }
`;

export const StyledCopyLinkButton = styled(Button)`
  padding: 20px 25px !important;
  background-color: white !important;
  color: ${theme.palette.primary.main} !important;
  cursor: pointer !important;
  border-radius: 8px !important;
`;

export const StyledWhatsappButton = styled(Button)`
  padding: 15px 25px !important;
  background-color: #45c655 !important;
  color: white !important;
  cursor: pointer !important;
  font-size: 17px !important;
  border-radius: 8px !important;
  width: 100% !important;
`;

export const StyledTelegramButton = styled(Button)`
  padding: 15px 30px !important;
  background-color: #1e90cb !important;
  color: white !important;
  cursor: pointer !important;
  font-size: 17px !important;
  border-radius: 8px !important;
  width: 100% !important;
`;

export const StyledopyLinkButton = styled(Button)`
  padding: 15px 30px !important;
  background-color: white !important;
  color: #1e90cb !important;
  border: 2px solid #1e90cb !important;
  cursor: pointer !important;
  font-size: 17px !important;
  border-radius: 8px !important;
  width: 100% !important;
`;

export const StyledButtonsDiv = styled.div`
  margin-top: 10px !important;
  margin-bottom: 60px !important;
  & > .text {
    font-weight: 400;
    line-height: 2.15;
    margin: 0 !important;
    font-size: 16px;
    color: #080a37;
  }
`;

export const StyledSpan = styled.span`
  padding: 4px;
  background: ${theme.palette.primary.dark};
  display: inline-block;
  border-radius: 100%;
  width: 40px;
  height: 40px;
  color: white;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledMainDiv = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  background: white;
  // margin-top: 10px;
  // margin-bottom: 10px;
  padding: 0;
`;
export const StyledAccordion = styled(Accordion)`
  width: 100%;
  box-shadow: none !important;
  padding: 0;
  border-bottom: 2px solid #0000002b;
  border-radius: 0 !important;
  & > div {
    padding: 0;
  }
`;

export const StyledTypographyText = styled(Typography)`
  direction: rtl;
  text-align: justify;
  padding: 15px;
  padding-top: 5px;
  font-size: 14px !important;
  line-height: 2;
  color: #1e1e1e;
  text-indent: 12px;
`;

export const StyledTypographyDiv = styled.div`
  width: 100%;
  display: flex;
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;
